// The 🟢 / 🔴 N / 🔵 badge every Flutter device card shows in its top-left
// corner, backed by the cached liveness lookup in core/devices/deviceStatus.

import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, useTheme } from '@mui/material';
import { getStatusCached } from '../../../core/devices/deviceStatus';

export default function LivenessBadge({ uniqueNumber }) {
  const [value, setValue] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    if (!uniqueNumber) return undefined;
    let alive = true;
    setValue(null);
    getStatusCached(uniqueNumber).then((v) => { if (alive) setValue(v); });
    return () => { alive = false; };
  }, [uniqueNumber]);

  if (value == null) return <CircularProgress size={16} thickness={2} />;

  return (
    <Box
      component="span"
      sx={{
        fontSize: 14,
        fontWeight: 700,
        color: theme.sli.text,
        textShadow: '0 0 2px rgba(0,0,0,0.54)',
      }}
    >
      {value}
    </Box>
  );
}
